import * as React from 'react';
import { OnIgnoreEnter } from '../AnalyseApp';

interface FixedCommentsButtonProps {
    onClick: () => void;
    selectedCommentsCount: number;
}

export const FixedCommentsButton = (props: FixedCommentsButtonProps) => {
    return (
        <button id="FixedComments" className="btn btn-primary" type="button" onClick={() => props.onClick()} onKeyDown={OnIgnoreEnter}>
            Fixed Comments&nbsp;
            <span id="SelectedCommentsCountBadge" className="badge badge-info">{props.selectedCommentsCount}</span>
        </button>
    );
}
